/*
 * -----------------------------------------------------------------------
 *  <copyright file="donut/display.ts" company="Triumph Research Intelligence">
 *      Copyright (C) 2022 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import DonutChart, { IOpraDonutSeries } from 'views/components/core/charts/donut-chart';

const getDonut = ({ getRef, panelState, siteId }: any) => {
    if (!panelState?.panelData?.panelData?.length || !panelState.panelData.panelData[0].donutForStudy) {
        return <span> The preview cannot be displayed as data is not available </span>;
    }

    const seriesData =
        !siteId && panelState.panelData.panelData[0].donutForStudy?.length > 0
            ? panelState.panelData.panelData[0].donutForStudy.map(
                  (d: any): IOpraDonutSeries => ({
                      name: d.name,
                      colour: undefined, // colours are set at chart level in DonutChart, using a theme
                      segmentSize: d.count,
                  }),
              )
            : [];
    if (siteId && panelState.panelData.panelData[0].donutForSiteIds[siteId]?.length) {
        seriesData.push(
            ...panelState.panelData.panelData[0].donutForSiteIds[siteId].map(
                (d: any): IOpraDonutSeries => ({
                    name: d.name,
                    colour: undefined, // colours are set at chart level in DonutChart, using a theme
                    segmentSize: d.count,
                }),
            ),
        );
    }

    return (
        <DonutChart
            getRef={getRef}
            title={panelState.chartConfig.plotTitle}
            threeDee={panelState.chartConfig.threeDee}
            showLegend={panelState.hideLegend ? !panelState.hideLegend : true}
            data={seriesData}
            showDataLabels
            entityType={panelState.entityType}
            onClick={() => {}}
            hidePlotTitle={panelState.hidePlotTitle}
        />
    );
};

export { getDonut };
